import { useCallback, useState } from 'react';
import { Colors, Icon, Overlay2, OverlaysProvider } from '@blueprintjs/core';

import {
  BottomRow,
  ButtonGrid,
  CardContainer,
  Display,
  FullScreenCard,
  RoundButton,
} from './styles';
import UserInputDisplay from './UserInputDisplay';
import Loading from '../Loading';

export interface PinPadProps {
  username: string;
  onSetUsername: (username: string) => void;
  onPinAction: (pin: string) => void;
  isLoading?: boolean;
}

const PinPad = ({
  username,
  onSetUsername,
  onPinAction,
  isLoading,
}: PinPadProps) => {
  const [pin, setPin] = useState('');

  const handleButtonClick = useCallback(
    (value: number) => {
      if (pin.length < 6) {
        setPin(`${pin}${value}`);
        if (pin.length === 5) {
          onPinAction(pin + value);
          setPin('');
        }
      }
    },
    [onPinAction, pin],
  );

  const handleBack = () => {
    setPin(pin.slice(0, -1));
  };

  const handleSubmit = useCallback(() => {
    onPinAction(pin);
    setPin('');
  }, [onPinAction, pin]);

  const handleSetUsername = useCallback(
    (username: string) => {
      onSetUsername(username.trim());
    },
    [onSetUsername],
  );

  return (
    <OverlaysProvider>
      <Overlay2 isOpen={true}>
        <CardContainer>
          <FullScreenCard>
            {isLoading ? (
              <Loading message="Loading" whiteText />
            ) : (
              <>
                <UserInputDisplay
                  username={username}
                  onUserNameChanged={handleSetUsername}
                />
                {username && (
                  <>
                    <Display>{pin || 'Digite o PIN'}</Display>
                    <ButtonGrid>
                      {Array.from({ length: 9 }, (_, i) => (
                        <RoundButton
                          key={i + 1}
                          onClick={() => handleButtonClick(i + 1)}
                        >
                          {i + 1}
                        </RoundButton>
                      ))}
                    </ButtonGrid>
                    <BottomRow>
                      <RoundButton onClick={handleBack}>
                        <Icon icon="arrow-left" />
                      </RoundButton>
                      <RoundButton onClick={() => handleButtonClick(0)}>
                        0
                      </RoundButton>
                      <RoundButton
                        onClick={handleSubmit}
                        $backgroudColor={Colors.GREEN3}
                      >
                        <Icon icon="arrow-right" />
                      </RoundButton>
                    </BottomRow>
                  </>
                )}
              </>
            )}
          </FullScreenCard>
        </CardContainer>
      </Overlay2>
    </OverlaysProvider>
  );
};

export default PinPad;
